export default __webpack_public_path__ + "static/media/catalog_point_img01.c5d1761a.svg";